// getGiftData.js
'use strict';
import { Collection, fromJS } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

import getResourceUrl from '../resource/getResourceUrl.js';
import { PUBLIC } from '../resource/resourceUrlTypeConstants.js';
import getRemoteConfigData from './getRemoteConfigData.js';
import {
  LIVESTREAM_ANIMATION_GIFTS,
  PUBLIC_PRODUCT_URL_PATH,
} from '../RemoteConfigKeys.js';

/**
 * Select gift data by id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} id - gift id.
 * @return {any} The selected gift data.
 */
const getGiftData = createCachedSelector(
  (state, id) => id,
  (state, id) => state.getIn(['gift', 'items', id]) || fromJS({}),
  (state, id, dataKey) => dataKey,
  state => getRemoteConfigData(state, PUBLIC_PRODUCT_URL_PATH),
  state => getRemoteConfigData(state, LIVESTREAM_ANIMATION_GIFTS),
  (id, item, dataKey, publicProductUrlPath, livestreamAnimationGiftList) => {
    let result = item.get(dataKey);
    if (dataKey === 'image') {
      /* note:
         because `/gift/${giftId}` just return gift 'id' and 'price',
         So will to trying to fetch gifts image.
       */
      const isAnimationGift = livestreamAnimationGiftList.includes(id);
      result = getResourceUrl({
        path: publicProductUrlPath,
        endpoint: `/${id}.png${isAnimationGift ? '?format=SOURCE' : ''}`,
        resourceType: PUBLIC,
      }).href;
    }
    if (dataKey === 'largeImage') {
      const isAnimationGift = livestreamAnimationGiftList.includes(id);
      result = getResourceUrl({
        path: publicProductUrlPath,
        endpoint: `/${id}_large.png${isAnimationGift ? '?format=SOURCE' : ''}`,
        resourceType: PUBLIC,
      }).href;
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)((state, id, dataKey) => `${id}:${dataKey}`);

export default getGiftData;
